(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ALVERO: selector de ordenacion de la toolbar
  document.addEventListener('change', function(e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('alvero-sort__select')) return;
    var params = new window.URLSearchParams(window.location.search);
    params.set('sort_by', sel.value);
    params.delete('page');
    window.location.search = params.toString();
  }, true);

  // ALVERO: open filters drawer on custom button click
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.alvero-filters-button');
    if (!btn) return;
    e.preventDefault();
    var dialog = document.querySelector('#filters-drawer dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // fallback: trigger the native toggle button
      var nativeBtn = document.querySelector('.facets-toggle__button');
      if (nativeBtn) nativeBtn.click();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
